<template>
    <h3 class="subtitle">
        <span v-if="hasProperty">
            Thank you for your interest in "{{ property.strShortAddress }}".
            <br />
        </span>
        <slot></slot>
    </h3>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
    computed: {
        ...mapState('leadProperty', [
            'property',
        ]),
        ...mapGetters('leadProperty', [
            'hasProperty',
        ]),
    },

    mounted() {
        this.getProperty();
    },

    methods: {
        getProperty() {
            if(! this.hasProperty) {
                this.$store.dispatch('leadProperty/getRow');
            }
        },
    },
};
</script>
